import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PrintMethodReferenceService extends BaseReferenceService {
  constructor() {
    super('PrintMethodReference');
  }
}
